<template>
	<div>
		<iframe id="mapPage" frameborder="0"
			src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=EJNBZ-SMKE3-ZDC3W-Y5UTS-Z4SRO-DYFRE&referer=myapp"></iframe>
		<div class="form">
			<div class="form-img">
				<img src="../../assets/images/ershoufang.png" />
			</div>
			<div class="form-box">
				<div class="form-box-t">
					您房子的图片
					<small>上传清晰全面的房源图片更容易接到客户的来电哦</small>
				</div>
				<div class="form-box-c" v-if="refer=='wechat'">
					<upload @change="getPictures" />
				</div>
				<div class="form-box-c" v-if="refer=='qianfan'  || refer=='pc'">
					<upload @change="getPictures" />
					
				</div> 
			</div>

			<div class="form-box">
				<div class="form-box-t">选择小区</div>
				<div class="form-box-c">
					<marea :lists="configs.area" @change="getXiaoqu" />
				</div>
			</div>


			<div class="form-box">
				<div class="form-box-t">户型</div>
				<div class="form-box-c">
					<huxingpicker @change="getHuxing" :lists="[configs['shi'],configs['ting'],configs['wei']]">
					</huxingpicker>
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">楼层</div>
				<div class="form-box-c">
					<loucengpicker @change="getLouceng" :lists="[configs['louceng1'],configs['louceng2']]">
					</loucengpicker>
				</div>
			</div>
			<van-row :gutter="15">
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">建筑面积</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.mianji" />
									<div class="unit">m²</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">套内面积</div>
						<div class="form-box-c">
							<div class="form-box-tag">
								<div class="form-input-flex">
									<input type="number" class="form-input" v-model="formItem.taonei" />
									<div class="unit">m²</div>
								</div>
							</div>
						</div>
					</div>
				</van-col>
			</van-row>
			<div class="form-box">
				<div class="form-box-t">出售价格(0为面议)</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-flex">
							<input type="number" class="form-input" v-model="formItem.price" />
							<div class="unit">万元</div>
						</div>
					</div>
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">朝向</div>
				<div class="form-box-c">
					<formtag @change="getChaoxiang" :lists="configs['chaoxiang']"></formtag>
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">装修程度</div>
				<div class="form-box-c">
					<formtag @change="getZhuangxiu" :lists="configs['zhuangxiu']"></formtag>
				</div>
			</div>

			<div class="form-box">
				<div class="form-box-t">房屋属性</div>
				<div class="form-box-c">
					<formtag @change="getShuxing" :lists="['商住房','商品房','安置房','小产权房']"></formtag>
				</div>
			</div>
			<van-row :gutter="15">
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">电梯</div>
						<div class="form-box-c">
							<formtag @change="getDianti" :nums="12" :lists="['有电梯','无电梯']"></formtag>
						</div>
					</div>
				</van-col>
				<van-col :span="12">
					<div class="form-box">
						<div class="form-box-t">选择年代</div>
						<div class="form-box-c">
							<niandai @change="getNiandai" :lists="configs['year']" />
						</div>
					</div>
				</van-col>
			</van-row>

			<div class="form-box">
				<div class="form-box-t">您房子的特色</div>
				<div class="form-box-c">
					<van-checkbox-group v-model="formItem.tese">
						<van-checkbox v-for="(item, index) in configs['tese2']" :key="index"
							:name="item">{{ item }}</van-checkbox>
					</van-checkbox-group>
				</div>
			</div>

			<div class="form-box">
				<div class="form-box-t">联系人</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<input type="text" v-model="formItem.username" />
						</div>
					</div>
				</div>
			</div>

			<div class="form-box">
				<div class="form-box-t">联系电话</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<input type="number" v-model="formItem.phone" />
						</div>
					</div>
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">房源描述</div>
				<div class="form-box-c">
					<div class="form-box-tag">
						<div class="form-input-float">
							<textarea v-model="formItem.content" rows="4"
								placeholder="详细的描述房屋状况，可以帮你快速的出售房源（5-2000个字符）"></textarea>
						</div>
					</div>
				</div>
			</div>
			<div class="form-box">
				<div class="form-box-t">
					<van-button type="info" block @click="post">发布</van-button>
				</div>
			</div>
		</div>
		<footbar></footbar>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;
	import Formtag from "../commpents/tag";
	import Selecttime from "../commpents/Selecttime";
	import Ruzhu from "../commpents/ruzhu";
	import Huxingpicker from "../commpents/huxingpicker";
	import Loucengpicker from "../commpents/loucengpicker";
	import Upload from "../commpents/upload";
	import uploadSingle from "../commpents/uploadSingle.vue";
	import Footbar from "../commpents/footbar";
	import District from "../commpents/district";
	import Community from "../commpents/community";
	import Wechat from "../commpents/wechat";
	import Tencentmap from "../commpents/tencentmap";
	import Marea from "../commpents/marea";
	import Niandai from "../commpents/niandai";
	import {
		Checkbox,
		CheckboxGroup,
		Card,
		SubmitBar,
		Toast,
		Cell,
		CellGroup,
		Button,
		Tabbar,
		TabbarItem,
		Icon,
		Row,
		Col,
		Tag,
		Dialog
	} from "vant";

	export default {
		components: {
			[Card.name]: Card,
			[Checkbox.name]: Checkbox,
			[SubmitBar.name]: SubmitBar,
			[CheckboxGroup.name]: CheckboxGroup,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Dialog.Component.name]: Dialog.Component,
			[Icon.name]: Icon,
			[Row.name]: Row,
			[Col.name]: Col,
			[Tag.name]: Tag,
			Formtag,
			Selecttime,
			Ruzhu,
			Huxingpicker,
			Loucengpicker,
			Upload,
			Footbar,
			District,
			Community,
			Wechat,
			Tencentmap,
			Marea,
			Niandai,
			uploadSingle
		},

		data() {
			return {
				getInitUrl: root + "post/init",
				getPostUrl: root + "post/ershoufang",
				active: "home",
				isactive: false,
				refer: "",
				islogin: 0,
				agent: 0,
				configs: [],
				formItem: {
					id: 0,
					community: "",
					area: {},
					huxing: [],
					chaoxiang: "",
					louceng: [],
					mianji: "",
					taonei: "",
					map: {},
					type: "",

					shuxing: "",
					dianti: "",
					niandai: "",
					pay: "",
					price: "",
					pictures: [],
					phone: "",
					username: "",
					title: "出售",
					tese: [],
					zhuangxiu: "",
					content: ""
				}
			};
		},

		mounted() {
			window.scrollTo(0, 0);
			this.init();
		},

		methods: {
			init() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.configs = reponseData.configs;
						self.formItem.username = reponseData.name;
						self.formItem.phone = reponseData.mobile;
						self.refer = reponseData.refer;
						self.islogin = reponseData.islogin;
						self.agent = reponseData.agent;
						if (self.islogin == 0) {
							self.$router.push("/login");
						}
					},
					error: function() {
						self.$toast("system error");
					}
				});
			},
			getXiaoqu(value) {
				this.formItem.community = value;
			},
			getChaoxiang(value) {
				this.formItem.chaoxiang = value;
			},

			getLouceng(value) {
				this.formItem.louceng = value;
			},
			getMap(value) {
				this.formItem.map = value;
			},
			getHuxing(value) {
				this.formItem.huxing = value;
			},
			getZhuangxiu(value) {
				this.formItem.zhuangxiu = value;
			},
			getLeixing(value) {
				this.formItem.leixing = value;
			},
			getShuxing(value) {
				this.formItem.shuxing = value;
			},
			getDianti(value) {
				this.formItem.dianti = value;
			},
			getNiandai(value) {
				this.formItem.niandai = value;
			},
			getYongtu(value) {
				this.formItem.yongtu = value;
			},

			getPictures(value) {
				this.formItem.pictures = value;
				console.log(value);
			},

			post() {
				if (this.isactive) {
					this.$toast("已经提交");
					return;
				}
				var self = this;
				self.$toast.loading({
					mask: true,
					duration: 0,
					message: "数据提交中"
				});
				self.isactive = true;
				$.ajax({
					url: self.getPostUrl,
					timeout: 120000,
					dataType: "json",
					type: "post",
					data: self.formItem,
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.$toast.clear();
						if (reponseData.status == 1) {
							self.isactive = true;
							// self.$toast(reponseData.message);
							self.$router.push("/post/sticky/" + reponseData.data[0] + "/ershoufang");

							// self.$dialog
							//   .alert({
							//     title: "提示",
							//     message: "您的房源发布成功，后台正在审核"
							//   })
							//   .then(() => {
							//     self.$router.push("/");
							//   });
						} else if (reponseData.status == 2) {
							self.$toast("发布成功");
							self.$router.push("/user/agent/ershoufang");
						} else {
							self.$toast(reponseData.message);
							self.isactive = false;
						}
					},
					error: function() {
						self.isactive = false;
						self.$toast.clear();
						self.$toast("system error");
					}
				});
			}
		}
	};
</script>

<style scoped>
	#mapPage {
		width: 100vw;
		height: 100vh;
		display: none;
	}

	.van-checkbox-group {
		display: flex;
		flex-flow: wrap;
		background-color: #f8f8f8;
		padding: 10px 0 10px 15px;
		border-radius: 4px;
	}

	.van-checkbox {
		width: 33.333333%;
		margin: 5px 0;
	}
</style>>